import type { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';

const getRandomFloat = () => {
  if (typeof crypto === 'undefined' || typeof crypto.getRandomValues !== 'function') {
    return 0.5;
  }
  const values = new Uint32Array(1);
  crypto.getRandomValues(values);
  return values[0] / (0xffffffff + 1);
};

const getRandomInt = (max: number) => Math.floor(getRandomFloat() * max);

export function generateMockSeries({
  namePrefix = 'mock',
  field = 'Mid',
  idSuffix = 'Mid',
  nPoints = 1000,
  yMin = 300,
  yMax = 1000,
  color = '#00BFFF'
} = {}): ExtendedSeriesOptionsType {
  const startDate = new Date('2020-01-01').getTime();
  const endDate = Date.now();

  const name = `${namePrefix}${getRandomInt(1000)}`;
  const id = `${name}-${idSuffix}`;

  // Set starting price near the center of the range
  let price = +(yMin + (yMax - yMin) / 2).toFixed(5);

  // Create equally-spaced timestamps
  const timestamps = Array.from({ length: nPoints }, (_, i) =>
    Math.floor(startDate + ((endDate - startDate) * i) / (nPoints - 1))
  );

  // Generate data as a random walk (simulating real price movement)
  const data = timestamps.map((x, i) => {
    if (i !== 0) {
      // Simulate a small percentage change per step
      const randomChange = (getRandomFloat() - 0.5) * 0.003; // up to ±0.15%
      price += price * randomChange;
      // Clamp to range
      price = Math.max(yMin, Math.min(yMax, price));
      price = +price.toFixed(5);
    }
    return {
      x,
      y: price,
      custom: {
        periodAbs: 'Prompt',
        decimalPlaces: 5
      }
    };
  });

  return {
    showInNavigator: true,
    type: 'line',
    name,
    data,
    id,
    marker: {
      radius: 1,
      symbol: 'circle'
    },
    custom: {
      decimalPlaces: 2,
      hideName: true,
      field,
      combinedIndex: 0,
      Code: `GX${getRandomInt(1000)}`,
      Period: '1',
      PeriodType: 'Prompt',
      TimeRef: '1630',
      type: 'Last',
      TimeZone: 'Europe/London',
      Commodity: 'Commodity',
      PricingBasis: 'Flat',
      Alias: 'Alias',
      Currency: 'USD',
      Frequency: 'Daily',
      HolidayCalendar: 'Holidays_GX_Europe',
      Title: id,
      TradingHub: 'NWE',
      DeliveryBasis: 'DeliveryBasis',
      Source: 'GX',
      Units: 'MT'
    },
    color
  };
}
